module.exports = __webpack_public_path__ + "img/horizontal_7_5_9016.3d0da474.png";